import { Component, ElementRef, EventEmitter, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';

import { ActivatedRoute, NavigationEnd, NavigationStart, Router } from '@angular/router';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ShowcaseService } from 'src/app/core/services/showcase/showcase.service';
import { PurchaseFlowComponent } from 'src/app/shared/cinejoy/common/purchase-flow/purchase-flow.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SpotlightService } from 'src/app/core/services/spotlight.service';
import { RateMovieComponent } from '../dialog/new-post/rate-movie/rate-movie.component';
import { Location } from '@angular/common';
import { DomSanitizer, Meta, Title } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';
import { StripePurchasePopupComponent } from 'src/app/features/bulk-purchase/stripe-purchase-popup/stripe-purchase-popup.component';
import { EventType } from 'src/app/features/passport/models/passport.models';
import { AgileIntegrationService } from 'src/app/core/services/agile/agile-integration.service';
import { AuthenticationService } from 'src/app/core/services/Authentication/authentication.service';
import { BookmarkPopupComponent } from 'src/app/features/spotlight/bookmark-popup/bookmark-popup.component';
import { UnlockPopupComponent } from 'src/app/features/spotlight/unlock-popup-component/unlock-popup-component.component';
import { AdminService } from 'src/app/core/services/admin-apis/admin.service';
declare const bootstrap: any;

@Component({
  selector: 'app-new-movie-info',
  templateUrl: './new-movie-info.component.html',
  styleUrls: ['./new-movie-info.component.scss'],
})
export class NewMovieInfoComponent implements OnInit, OnDestroy {
  private static readonly stripPaymentSessionEventIdKey = 'stripe_payment_session_id';
  buttons: string[] = ['Laughs', 'Feature', 'Sci-Fi', 'Mindbender', 'Love', 'Staff Pick'];

  router: any;
  public Comments: any = [];
  today: number = Date.now();
  Url: string;
  shareUrl: string;
  type: 'facebook' | 'twitter';
  showTrailer: boolean = false;
  showSpecialFeatures: boolean = false;
  isAgileGateWayActive: boolean = environment.showcaseAgilePurchaseEnabled;
  pageUrl: string = '';
  leftArrow: any = 'assets/images/cinejoy/arrow-left.png';

  constructor(
    public showcaseService: ShowcaseService,
    private route: ActivatedRoute,
    private modalService: NgbModal,
    private spotlightService: SpotlightService,
    private sanitizer: DomSanitizer,
    private dialog: MatDialog,
    private _location: Location,
    private routerurl: Router,
    private agileIntegration: AgileIntegrationService,
    private authService: AuthenticationService,
    private adminService: AdminService,
    private meta: Meta,
    private titleService: Title,
    private location: Location
  ) {
    this.id = route.snapshot.params.id;
  }

  data: any = { sourceType: 'url', url: 'https://twitter.com/Creatics2' };
  movie: any = [];
  GiveRate: string;
  Shorts: any = [];
  starCast: any = [];
  name: any;
  showSideBar: boolean = false;
  ShortDescriptive1: any = [];
  description: any = [];
  country: any = [];
  movieList: any = [];
  rating: number;
  language: string;
  duration: any;
  tags: any = [];
  categories: any = [];
  subCategories: any = [];
  id: any;
  public errorApi = true;
  result = [];
  dates: any;
  subCat: any = [];
  backArrow = "assets/images/cinejoy/arrow-left.png";
  officialLogo = "assets/images/showcase/cinejoy-official-new.png"
  trailerUrl: any;
  spotlightMovies: any = [];
  counter = 0;
  isSecondarySideNavOpen: boolean;
  screeningPartyList: any = [];
  splContent: any;
  splContent1: any;
  isUserLoggedIn: boolean;
  isExpanded = false;
  showCast: boolean = false;
  showMore: boolean = false;
  isButtonClicked: boolean = false;
  isTrailer: boolean = false;
  isSpecialContentMob: boolean = false;
  isCastContentMob: boolean = false;
  isMoreInfoMob: boolean = false;
  isBuyButtonActive: boolean = false;
  showcaseTickets: any = new Array();
  @ViewChild('readmoremodal') readmoremodal!: ElementRef;
  readMoreString: any = `<span class="read-more" data-bs-toggle="modal" data-bs-target="#movieDescription" id="read-more">Read More</span>`
  ngOnInit(): void {
    this.getShowcaseList();
    this.showTrailer = true;
    this.authService.checkUserAuthenticated().subscribe((res) => {
      if (res.userId > 0) {
        this.showcaseService.fetchTickets();
        this.checkForTicketAndSubscriptionDetails();
      }
    },
      (err) => { }
    );

    this.populateCallbackUrl();
  }

  fetchTickets(): void {
    this.agileIntegration.fetchTickets().subscribe(
      (response) => {
        const tickets = response.agiletixEvents ? response.agiletixEvents : [];

        this.showcaseTickets = tickets.filter(
          (ticket) =>
            ticket.type !== undefined &&
            ticket.type !== null &&
            ticket.type.toLowerCase().includes('showcase')
        );
        tickets.map(ticket => {
          if (ticket.purchaseTransactionType === 'SUBSCRIPTION_ALL' || ticket.purchaseTransactionType === 'SUBSCRIPTION_SHOWCASE') {
            this.isBuyButtonActive = true;
          }
        })
        this.showcaseTickets = this.showcaseTickets.sort(
          (a, b) =>
            new Date(a.StartDateTime).getTime() -
            new Date(b.StartDateTime).getTime()
        );
        if (this.showcaseTickets.find((v) => (v.AccessStatus === 'AccessValid' || v.AccessStatus === 'BeforeEvent') && v.ParentID == this.movie.eventId)) {
          this.isBuyButtonActive = true;
        }


      },
      console.error
    );
  }

  checkForTicketAndSubscriptionDetails() {
    this.showcaseService.ShowcaseTicketAndSubscriptionListObs$.subscribe({
      next: (tickets) => {
        tickets.map(ticket => {
          // if (this.showcaseTickets.find((v) => (v.) {

          if (ticket.purchaseTransactionType === 'TICKET') {
            if ((ticket.AccessStatus === 'AccessValid' || ticket.AccessStatus === 'BeforeEvent') && ticket.ParentID == this.movie.eventId) {
              this.isBuyButtonActive = true;
              return
            }
          }

          if (ticket.purchaseTransactionType === 'SUBSCRIPTION_ALL' || ticket.purchaseTransactionType === 'SUBSCRIPTION_SHOWCASE') {
            this.isBuyButtonActive = true;
            return;
          }
        })
      }
    })

  }

  getShowcaseList(loadTabs = true) {
    this.showcaseService.ShowcaseGetEventById(this.id).subscribe((res) => {
      this.movie = res;
      this.checkForPurchaseCallback();
      this.movie.truncatedDescription = this.truncatedText();

      if (this.movie.FullDescription.length > 200) {
        setTimeout(() => {
          const md = document.getElementById("movie-desc");
          const md1 = document.getElementById("movie-desc1");
          if (!md) return; // Exit if the element is not found

          // Calculate character limit based on screen size and resolution
          const screenWidth = window.innerWidth;
          const devicePixelRatio = window.devicePixelRatio || 1; // Pixel density for high-res screens
          let charLimit = 150; // Default for standard screens

          // Adjust charLimit based on screen width
          if (screenWidth < 768) {
            charLimit = 150; // Mobile screens
          } else if (screenWidth >= 768 && screenWidth < 1024) {
            charLimit = 200; // Tablets
          } else if (screenWidth >= 1024 && screenWidth < 1440) {
            charLimit = 230; // Medium-sized desktops
          } else if (screenWidth >= 1440 && screenWidth < 1640) {
            charLimit = 280; // Large desktops
          } else if (screenWidth >= 1640) {
            charLimit = 340; // High-resolution large screens
          }

          const fullText = this.movie.FullDescription;
          const truncatedText = fullText.substring(0, charLimit) + '...';
          if (fullText.length <= truncatedText.length) {
            return;
          }
          md.innerHTML = `
          ${truncatedText}
          <span class="read-more" style="color: white; text-decoration: underline; cursor: pointer;">
            Read More
          </span>
        `;
          md1.innerHTML = `
        ${truncatedText}
        <span class="read-more1" style="color: white; text-decoration: underline; cursor: pointer;">
          Read More
        </span>
      `;
          const readMoreLink = md.querySelector('.read-more');
          readMoreLink.addEventListener('click', () => {
            const modalElement = document.getElementById('movieDescription');
            const bootstrapModal = new bootstrap.Modal(modalElement);
            bootstrapModal.show();
          });
          const readMoreLink1 = md1.querySelector('.read-more1');
          readMoreLink1.addEventListener('click', () => {
            const modalElement = document.getElementById('movieDescription');
            const bootstrapModal = new bootstrap.Modal(modalElement);
            bootstrapModal.show();
          });
          // Append the "Read More" link to the element
          //  md.appendChild(readMoreLink);
        }, 2000); // Delay to simulate loading
      }

      let url = `https://player.vimeo.com/video/${this.movie.trailer}?quality=1080p`;
      let url1 = `https://player.vimeo.com/video/${this.movie.specialFeature}?quality=1080p`;
      let url2 = `https://player.vimeo.com/video/${this.movie.video2}?quality=1080p`;
      this.trailerUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
      this.splContent = this.sanitizer.bypassSecurityTrustResourceUrl(url1);
      this.splContent1 = this.sanitizer.bypassSecurityTrustResourceUrl(url2);
      if (this.movie.user > 0) {
        this.getSpotlightPremierList();
        this.getScreeningPartyList();
        this.fetchTickets();
      }
      this.id = res.id;
      this.errorApi =
        res.moviesArray == null ||
        res.moviesArray === 0 ||
        res.moviesArray.length === 0;
      if (loadTabs) {
        this.switchTrailerTabs('trailer');
        this.switchCastTabs('cast');
        this.tabsControlMobile('trailer');
      }
    });


  }

  openDialogRateMovie() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.width = 'auto';
    dialogConfig.height = 'auto';
    dialogConfig.panelClass = "rate-movie-dialog";
    dialogConfig.data = { movieId: this.id, moveDetails: this.movie }
    let movieId = this.id;
    this.dialog.open(RateMovieComponent, dialogConfig).afterClosed().subscribe((res) => {
      this.id = this.movie.eventId
      this.getShowcaseList(false)
    });;
  }

  openSideBar() {
    this.showSideBar = !this.showSideBar;
  }

  open(Id: number, movieList: any, purchaseStage: string): void {
    if (this.isAgileGateWayActive) {
      const modalRef = this.modalService.open(PurchaseFlowComponent, {
        size: 'xl',
        backdrop: 'static',
      });
      modalRef.componentInstance.eventId = Id;
      modalRef.componentInstance.premiere = movieList;
      modalRef.componentInstance.purchaseStage = purchaseStage;
    } else {
      if (this.isButtonClicked) {
        return;
      }
      this.isButtonClicked = true;

      this.authService.checkUserAuthenticated().subscribe(
        (res) => {
          if (res.userId === 0) {
            alert("Please login to creatics to purchase tickets.");
            this.isButtonClicked = false;
            location.href = '/login?referer=cinejoy/showcase/moviepage/' + this.movie.eventId + '/' + this.movie.name + "/" + this.movie.cinejoyYears;

            return;
          }
          else {
            this.openSinglePurchaseDialog(Id, movieList);
          }
        },
        (err) => {
          location.reload();
          this.isButtonClicked = false;
        }
      );

    }
  }

  openSinglePurchaseDialog(eventId: number, movieList: any) {
    localStorage.setItem(
      NewMovieInfoComponent.stripPaymentSessionEventIdKey,
      `${eventId}`
    );
    this.dialog
      .open(StripePurchasePopupComponent, {
        panelClass: 'pre-schedule-modalbox',
        width: '470px',
        height: 'auto',
        position: { top: '20px' },
        data: {
          eventId,
          eventType: EventType.SHOWCASE,
          showcaseEvent: movieList,
          mode: 'purchase',
          url: this.pageUrl,
          puchaseType: 'singlePurchase',
          purchaseTransactionType: 'TICKET'
        },
      })
      .afterClosed()
      .subscribe((res) => {
        this.isButtonClicked = false;
      });
  }

  goAll() {
    document.getElementById('targetAll').scrollIntoView({
      behavior: 'smooth',
      block: 'start',
      inline: 'nearest',
    });
  }

  goAllScrollMobile() {
    document.getElementById('targetAllmobile').scrollIntoView({
      behavior: 'smooth',
      block: 'start',
      inline: 'nearest',
    });
  }
  navigateToScreeningParty() {
    this.routerurl.navigateByUrl(`/cinejoy/screening-parties/join`)
  }

  backClicked() {
    if (window.history.length > 1) {
      window.history.back()
    } else {
      this.routerurl.navigateByUrl(`/cinejoy/showcase`);
    }
  }


  backClickedMobile() {
    document.location.assign(`/cinejoy/showcase`)
  // window.history.back();
  // this.location.back()
}

  getSpotlightPremierList() {
    this.spotlightService.getData().subscribe((res) => {
      this.spotlightMovies = res;
    })
  }

  navigateToSpolightEvent(movie) {
    let name = movie.name.replace(/ /g, '-');
    this.routerurl.navigateByUrl(`/cinejoy/premiere/more-info/${movie.eventId}/${name}`)
  }

  checkSpotlightEvent(movie) {
    let item = this.spotlightMovies?.filter((v) => v.eventId == movie.eventId)
    if (item.length) {
      return true;
    } else {
      return false;
    }
  }

  getmovieName(moviename) {
    let name = moviename.replace(/[\s?]/g, '-');
    return name;
  }

  getScreeningPartyList() {
    this.spotlightService.getScreeningPartyList().subscribe((res) => {
      this.screeningPartyList = res;
    }, (err) => {
    })
  }

  checkScreeningPartyEvent(movie) {
    let item = this.screeningPartyList.filter((v) => v.cinejoyFeaturedMovie == movie.eventId)
    if (item.length) {
      return true;
    } else {
      return false;
    }
  }

  navigateToScreeningPartyEvent(movie) {
    let name = movie.name.replace(/ /g, '-');
  }

  shareButton(type: string) {
    let searchParams = new URLSearchParams();
    let url: string;
    const systemUrl = environment.apiURL + `cinejoy/showcase/moviepage/${this.movie.eventId}/${this.getmovieName(this.movie.name)}/${this.movie.cinejoyYears}`;
    switch (type) {
      case 'facebook':
        // searchParams.set('u', systemUrl);
        const baseUrl = new URL('https://www.facebook.com/sharer/sharer.php');

        const encodedUrl = encodeURIComponent(systemUrl);
        const encodedQuote = encodeURIComponent(this.movie.name);
        const encodedDescription = encodeURIComponent(this.movie.description);
        const shareUrl = `${baseUrl}?u=${encodedUrl}&title=${encodedQuote}`;
        this.titleService.setTitle(this.movie.name);

        // Update Open Graph Meta Tags
        this.meta.updateTag({ property: 'og:title', content: this.movie.name });
        this.meta.updateTag({ property: 'og:description', content: this.movie.description });
        this.meta.updateTag({ property: 'og:image', content: this.movie.eventImage });
        this.meta.updateTag({ property: 'og:url', content: systemUrl });
        setTimeout(() => {
          this.share(shareUrl.toString());
        }, 2000)
        break;

      case 'twitter':
        searchParams.set('url', "\n" + environment.apiURL + `cinejoy/showcase/moviepage/${this.movie.eventId}/${this.getmovieName(this.movie.name)}/${this.movie.cinejoyYears}`);
        searchParams.set('title', this.movie.name);
        searchParams.set('text', '\nExperience the Cinejoy Film Festival on Creatics.');
        url = 'https://twitter.com/share?' + searchParams;
        this.share(url);

        break;

      case 'email':
        const emailBody = encodeURIComponent(`Check out this movie: ${this.movie.name}\n\n${this.stripHtml(this.movie.description)}\n\n${systemUrl}`);
        url = `mailto:?subject=${encodeURIComponent(this.movie.name)}&body=${this.stripHtml(emailBody)}`;
        this.share(url);
        break;

      case 'pinterest':
        const pinterestURL = encodeURIComponent(environment.apiURL + `cinejoy/showcase/moviepage/${this.movie.eventId}/${this.getmovieName(this.movie.name)}/${this.movie.cinejoyYears}`);
        const imageURL = encodeURIComponent(this.movie.image); // Provide the image URL
        const description = encodeURIComponent(this.movie.description);
        url = `https://www.pinterest.com/pin/create/button/?url=${pinterestURL}&media=${imageURL}&description=${description}`;
        this.share(url);
        break;

      case 'copy-link':
        const linkToCopy = environment.apiURL + `cinejoy/showcase/moviepage/${this.movie.eventId}/${encodeURIComponent(this.getmovieName(this.movie.name))}/${this.movie?.cinejoyYears ? parseInt(this.movie?.cinejoyYears) : ''}`;
        this.copyToClipboard(linkToCopy);
        break; // No need to open a URL for copying

      case 'instagram':
        const instagramMessage = `Check out this movie: ${this.movie.name}\n\n${this.stripHtml(this.movie.description)}\n\n${systemUrl}`;
        url = `https://www.instagram.com/?text=${encodeURIComponent(instagramMessage)}&url=${encodeURIComponent(url)}`;

        navigator.clipboard.writeText(instagramMessage).then(() => {
          // Show Alert After Copying
          alert(`Text copied! Now go to Instagram and paste it.\n\n${this.stripHtml(instagramMessage)}`);
          this.share(url);

        }).catch(err => {
          console.error('Failed to copy:', err);
          alert('Failed to copy text. Please try again.');
        });
        break; // No URL for Instagram, but you can redirect if needed

      default:
        console.error('Unsupported share type:', type);
        break;
    }

  }

  copyToClipboard(text: string) {
    if (document.hasFocus()) {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard
          .writeText(text)
          .then(() => {
            alert('Link copied to clipboard!');
          })
          .catch((err) => {
            console.error('Clipboard API failed. Error:', err);
          });
      } else {
        // Fallback for older browsers
        this.fallbackCopyToClipboard(text);
      }
    } else {
      this.fallbackCopyToClipboard(text);
    }
  }

  // Fallback method for older browsers
  fallbackCopyToClipboard(text: string) {
    try {
      const tempInput = document.createElement('textarea');
      tempInput.value = text;
      tempInput.style.position = 'absolute';
      tempInput.style.left = '-9999px'; // Move off-screen
      document.body.appendChild(tempInput);
      tempInput.focus();
      tempInput.select();

      const successful = document.execCommand('copy');
      if (successful) {
        alert('Link copied to clipboard!');
      } else {
      }
    } catch (err) {
      alert('An error occurred while trying to copy the link. Please try again.');
    } finally {
      const tempInput = document.querySelector('textarea');
      if (tempInput) {
        document.body.removeChild(tempInput);
      }
    }
  }

  stripHtml(html: string): string {
    return html.replace(/<[^>]+>/g, ''); // Removes all HTML tags
  }

  share(url) {
    return window.open(
      url,
      '_blank',
      'toolbar=yes,scrollbars=yes,resizable=yes,top=500,left=300,width=700,height=700'
    );
  }


  switchTrailerTabs(data: any) {
    if (data === 'trailer') {
      this.showTrailer = true;
      this.showSpecialFeatures = false;
    } else if (data === 'special') {
      this.showSpecialFeatures = true;
      this.showTrailer = false;
    }
  }

  toggleContent() {
    this.isExpanded = !this.isExpanded;
  }

  switchCastTabs(data: any) {
    if (data === 'cast') {
      this.showCast = true;
      this.showMore = false;
    } else if (data === 'more') {
      this.showCast = false;
      this.showMore = true;
    }
  }

  truncatedText() {
    return this.movie?.FullDescription.length > 300 ? this.movie?.FullDescription.slice(0, 300) : this.movie?.FullDescription;
  }

  tabsControlMobile(data) {
    switch (data) {
      case 'cast':
        this.isCastContentMob = true;
        this.isMoreInfoMob = false;
        this.isTrailer = false;
        this.isSpecialContentMob = false;
        break;

      case 'more':
        this.isCastContentMob = false;
        this.isMoreInfoMob = true;
        this.isTrailer = false;
        this.isSpecialContentMob = false;
        break;

      case 'trailer':
        this.isCastContentMob = false;
        this.isMoreInfoMob = false;
        this.isTrailer = true; // Show the trailer
        this.isSpecialContentMob = false;
        break;

      case 'sp':
        this.isCastContentMob = false;
        this.isMoreInfoMob = false;
        this.isTrailer = false;
        this.isSpecialContentMob = true; // Show special content
        break;

      default:
        // Optionally handle an unknown value
        this.isCastContentMob = false;
        this.isMoreInfoMob = false;
        this.isTrailer = true;
        this.isSpecialContentMob = false;
        break;
    }

  }
  onLoad(event) { }
  private populateCallbackUrl() {
    this.pageUrl = window.location.href;
  }

  checkForPurchaseCallback() {
    const eventId = Number(
      localStorage.getItem(NewMovieInfoComponent.stripPaymentSessionEventIdKey)
    );
    this.route.queryParams.subscribe((queryParams) => {
      if (queryParams.session_id && this.movie.eventId === eventId) {
        this.isBuyButtonActive = true;
        this.dialog
          .open(StripePurchasePopupComponent, {
            panelClass: 'pre-schedule-modalbox',
            width: '600px',
            minHeight: 'auto',
            maxHeight: '75%',
            data: {
              eventId: this.movie.eventId,
              eventType: 'SHOWCASE',
              showcaseEvent: this.movie,
              mode: 'callback',
              sessionId: queryParams.session_id,
            },
          })
          .afterClosed()
          .subscribe((res) => {
            this.isBuyButtonActive = true;
            this.fetchTickets();
          });
      }
    });
  }

  formatRuntime(minutes) {
    const hours = Math.floor(minutes / 60);
    const remainingMinutes = minutes % 60;
    return `${hours}h ${remainingMinutes}min`;
  }

  bookmarkEvent(eventId: number, isBookmarked: boolean): void {
    this.adminService.getActiveSubscription().subscribe((res) => {
      if (res && res.length > 0 && res[0].purchaseTransactionType === 'SUBSCRIPTION_ALL') {
        const confirmationMessage = isBookmarked
          ? "Do you want to add this event to your Watchlist?"
          : "Do you want to remove this event from your Watchlist?";
        if (window.confirm(confirmationMessage)) {
          this.spotlightService.createOrUpdatePassholderWatchlist(eventId, isBookmarked, 'SHOWCASE').subscribe((res) => {
            if (res) {

              this.dialog.open(BookmarkPopupComponent, {
                data: { isBookmarked },
              });

              this.getShowcaseList();
            }
          });
        }

      } else {
        this.dialog.open(UnlockPopupComponent, {
          panelClass: 'zero-padding-dialog',
          data: { message: 'My Watchlist is an ' + '<a style="color: white !important;" href="/cinejoy/all-access-pass" target="_blank">All-Access Pass</a>' + ' holder’s feature that allows you to bookmark and organize your event and screening experience.' },
        });
      }
    });
  }
  alreadyBookmarkEvent(isBookmarked: boolean) {
    this.dialog.open(BookmarkPopupComponent, {
      data: { isBookmarked }
    }
    )
  }

  onClose() {
    this.showSideBar = false;
  }

  ngOnDestroy(): void {
    console.log('ondestroy')
    this.removeBackdrop()
    this.dialog.closeAll()
    
  }

  removeBackdrop() {
    const backdrops = document.querySelectorAll('.modal-backdrop');
    backdrops.forEach(backdrop => backdrop.remove()); 
  }
}
